module.exports = __webpack_public_path__ + "img/dolphin.763b84d4.png";